<template>
  <div>
    <v-card-title>
      <v-row class="d-flex  align-center pb-0" no-gutters>
        <v-col class="h6 grey--text text--darken-1" cols="10">
          {{ title }}
        </v-col>
        <v-col class="text-right pa-0">
          <v-btn @click="closeModal(name)" icon>
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ModalTitle',

  props: {
    name: {
      type: String,
      required: true,
    },

    title: {
      type: String,
    },
  },

  methods: {
    ...mapActions(['closeModal']),
  },
}
</script>
